export const config = {
    preloadDistance: 500,
    maxNumberItemsDefault: 24,
    intersectionObserverOptions: {
        margin: `350px 0px 350px 0px`,
        once: true,
    },
} as const;
